module.exports = __webpack_public_path__ + "static/media/gradually_launch_mobile.d6d801de.png";